export default {
  title: 'Easy Air Screen',
  subtitle: 'Turn your tablet into a wireless second monitor',
  description: 'Transform your tablet into a high-quality wireless display for macOS. Expand your workspace and boost productivity—no cables needed.',
  downloadMobile: 'Download Mobile App',
  purchasePromise: 'One-time purchase. No subscription or ads.',
  companionPromise: 'The Mac companion app is free, and no account is required.',
  downloadMacOS: 'Download for macOS (Universal)',
  quickSetup: 'Quick Setup',
  setupSteps: [
    'Install Easy Air Screen on your tablet',
    'Download and install the desktop app for macOS',
    'Connect both devices to the same Wi-Fi network',
    'Launch and connect!'
  ],
  performanceTip: 'Performance Tip',
  performanceDescription: 'For the best experience with minimal lag, use a 5GHz Wi-Fi connection on both devices. If you notice latency, try lowering the resolution in the app settings.',
  faqTitle: 'Frequently Asked Questions',
  faq: [
    {
      q: 'How is it different from Sidecar?',
      a: 'Easy Air Screen works even when the two devices use different Apple ID accounts. You can also use an Android tablet as a wireless secondary display for your Mac.'
    },
    {
      q: 'Can I use it with an Android tablet?',
      a: 'Yes. You can use an Android tablet as a wireless secondary display for your Mac. Connect both devices to the same Wi-Fi to extend or mirror your screen.'
    },
    {
      q: 'Can an iPhone become a secondary display?',
      a: 'Yes. An iPhone can be used as a wireless secondary display for your Mac. Choose either an extended desktop or a mirrored view when you connect.'
    },
    {
      q: 'Does it extend the screen or mirror it?',
      a: 'It supports both. Extend your Mac desktop onto another display, or mirror your current Mac screen when you need the same view on both devices.'
    },
    {
      q: 'Do I need internet access? Is my screen sent outside?',
      a: 'No internet connection is required. Devices connect directly on the same Wi-Fi, and your screen is not routed through or stored on an external server.'
    },
    {
      q: 'Is it a subscription?',
      a: 'No. The device app is a one-time purchase, not a subscription, and it has no ads. The companion app for Mac is free and requires no account.'
    },
    {
      q: 'Does it work with Windows PCs?',
      a: 'No. Easy Air Screen is designed for macOS only. Windows PCs are not supported at this time.'
    },
    {
      q: 'What should I do if the screen is choppy or slow?',
      a: 'Connect both devices to 5GHz Wi-Fi if available. If you still notice delay, lower the resolution in the app settings.'
    },
  ]
};
